import { useEffect, useRef } from "react";

type Opts = { behavior?: ScrollBehavior; element?: HTMLElement | null };

export default function useScrollToTopOnChange(
  deps: unknown[],
  { behavior = "smooth", element }: Opts = {}
) {
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return; // ikke scroll på første render
    }
    const target = element ?? window;
    if ("scrollTo" in target) {
      // @ts-ignore
      target.scrollTo({ top: 0, left: 0, behavior });
    } else {
      window.scrollTo({ top: 0, behavior });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
